<div *ngIf="showConfirm" class="card">
    <div class="card-header">
        <h4 class="card-title my-0">Confirm Job {{ jobId }}</h4>
    </div>
    <div class="card-body">
        <p>Enter the Phone number you used to Log your Job</p>
        <abi-form-field label="Telephone" cols="col-md-12" [errors]="[errorMessage]">

            <abi-phone-input *ngIf="withCountrySelector" [(ngModel)]="telephone"></abi-phone-input>
            <input *ngIf="!withCountrySelector" type="text" [mask]="phoneMask" [(ngModel)]="telephone" id="query-telephone" data-cy="query-telephone" />

        </abi-form-field>
    </div>
    <div class="card-footer d-flex justify-content-end">
        <button class="btn btn-outline-primary mr-2" (click)="back()" translate="System.Cancel"></button>
        <button class="btn btn-primary" (click)="confirmClick()" translate="System.Confirm"></button>
    </div>
</div>

<ng-container *ngIf="job">
    <abi-facebook-create *ngIf="isFacebook" [boundJob]="job"></abi-facebook-create>
    <abi-job-details [defaultTab]="isCod && defaultCodTab || isValidation && 'closeValidation' || 'summary'" *ngIf="!isFacebook" [boundJob]="job" [useRouting]="false"></abi-job-details>
</ng-container>

<ng-template #paymentFailed>
    <h5 mat-dialog-title>Payment Failed: {{ errorTitle }}</h5>
    <div mat-dialog-content>
        <p *ngIf="showBank" class="font-weight-bold text-danger">Please contact your bank for further information.</p>
        <p>{{ errorMessage }}</p>
        <p>{{ bankMessage }}</p>
    </div>
    <div mat-dialog-actions>
        <button mat-dialog-close mat-button>Ok</button>
    </div>
</ng-template>
